import { render, staticRenderFns } from "./ToogleContractType.vue?vue&type=template&id=1fa256fd"
import script from "./ToogleContractType.vue?vue&type=script&lang=js"
export * from "./ToogleContractType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports